export default __webpack_public_path__ + "c36e5453f69a4a4f985d2294ffe6ef7c.png";